module.exports = __webpack_public_path__ + "img/body-shape.c298eb62.svg";